import React, { Component } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';

const ImageComp = styled.img`
  max-height: 40px !important; 
  max-width: 160px;
  margin: 0 auto;
`;

const Wrapper = styled.div`
  width: 170px;
`;

// eslint-disable-next-line react/prefer-stateless-function
export default class CenterMode extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    // console.log(this)
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    const settings = {
      infinite: true,
      autoplay: true,
      speed: 300,
      autoplaySpeed: 1500,
      slidesToShow: 6,
      slidesToScroll: 1,
      initialSlide: 0,
      // variableWidth: true,
      centerMode: true,
      centerPadding: 0,
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 735,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
      <Slider ref={c => (this.slider = c)} {...settings}>
        <Wrapper>
          <ImageComp src="//brands/landing/swiggy.png" />
        </Wrapper>
        <Wrapper>
          <ImageComp src="//brands/landing/udaanlogo.png" />
        </Wrapper>
        <Wrapper>
          <ImageComp src="/brands/hije.png" />
        </Wrapper>
        <Wrapper>
          <ImageComp src="//brands/landing/daily.png" />
        </Wrapper>
        <Wrapper>
          <ImageComp src="//brands/landing/alibaba.png" />
        </Wrapper>
        <Wrapper>
          <ImageComp src="//brands/landing/shareit.png" />
        </Wrapper>
        <Wrapper>
          <ImageComp src="//brands/uber.png" />
        </Wrapper>
        <Wrapper>
          <ImageComp src="//brands/vivo.png" />
        </Wrapper>
        <Wrapper>
          <ImageComp src="//brands/landing/paytm.png" />
        </Wrapper>
        <Wrapper>
          <ImageComp src="//brands/landing/uc.png" />
        </Wrapper>
        <Wrapper>
          <ImageComp src="/brands/bookmyshow.png" />
        </Wrapper>
      </Slider>
    );
  }
}
